export const psychologicalImpacts = [
  {
    icon: "ri-heart-pulse-line",
    title: "急性应激反应",
    desc: "在事件发生后的最初几天，常出现心跳加速、手抖、恶心、无法进食或入睡。这是身体在危险信号下的正常反应，不代表你「太脆弱」。",
  },
  {
    icon: "ri-alarm-line",
    title: "持续的过度警觉",
    desc: "对手机提示音、陌生人的目光、街头议论过度敏感，总感觉被注视、被评价。这种警觉会大量消耗精力，让人白天疲惫、夜里清醒。",
  },
  {
    icon: "ri-emotion-sad-line",
    title: "抑郁与自我否定",
    desc: "当同一套说法被重复几千遍，人很容易开始相信它。自我怀疑、羞耻感、觉得「是不是我真的有问题」，是网暴后期最常见的状态。",
  },
  {
    icon: "ri-shield-user-line",
    title: "社交回避与关系收缩",
    desc: "为了不再被牵连，当事人往往主动退出群聊、删掉好友、拒绝聚会。关系网越缩越小，获得支持的通道也随之变窄。",
  },
  {
    icon: "ri-brain-line",
    title: "注意力与认知受损",
    desc: "无法专注工作学习，做决定变得困难，容易忘事。这不是能力下降，而是大脑长期处于应激状态后的资源占用。",
  },
  {
    icon: "ri-restart-line",
    title: "延迟出现的创伤反应",
    desc: "许多人是在舆论平息后才突然崩溃。当紧绷的弦松下来，被压抑的情绪才涌上来，这也是恢复过程中最容易被忽略的一段。",
  },
];

export const traumaPhases = [
  {
    phase: "冲击期",
    time: "事件后 0–72 小时",
    desc: "注意力被完全占据，反复刷新页面、试图自证、无法做其他事。此时最重要的是保存证据、告知可信任的人，并尽量维持基本饮食与睡眠。",
  },
  {
    phase: "抵抗期",
    time: "事件后 1–2 周",
    desc: "身体进入持续高强度应对状态，可能显得异常冷静、甚至效率很高。这种「还好」往往是透支，需要主动安排休息，而不是等到撑不住。",
  },
  {
    phase: "耗竭期",
    time: "事件后 2 周至数月",
    desc: "紧绷结束后出现明显低落、疲惫、回避与自我怀疑。这是寻求心理咨询的关键窗口，也是亲友最需要主动陪伴的阶段。",
  },
  {
    phase: "整合期",
    time: "数月至一年以上",
    desc: "开始能把这段经历讲成一个有边界的故事，而不是全部的自己。反复与回退是正常的，恢复不等于彻底忘记。",
  },
];

export const helpChannels = [
  {
    icon: "ri-delete-bin-6-line",
    title: "平台投诉与内容删除",
    desc: "对侵犯隐私、侮辱诽谤的内容逐条投诉，保留投诉编号与处理回执。必要时可多次、分批提交，提高处理优先级。",
  },
  {
    icon: "ri-file-shield-2-line",
    title: "证据保全与公证",
    desc: "及时截图、录屏并记录时间与账号信息，重要内容可申请电子证据公证。完整的证据链是后续维权能否成立的基础。",
  },
  {
    icon: "ri-phone-line",
    title: "心理援助与危机热线",
    desc: "当持续出现失眠、情绪低落或自我伤害念头时，请立即联系专业心理咨询或当地心理危机干预热线，不必等到「更严重」才求助。",
  },
  {
    icon: "ri-police-badge-line",
    title: "报警与法律途径",
    desc: "涉及人身威胁、隐私泄露、有组织的诽谤时，可向公安机关报案；也可通过民事诉讼要求停止侵害、赔礼道歉与赔偿。",
  },
  {
    icon: "ri-team-line",
    title: "找到可信任的人",
    desc: "把发生的事完整说给一个人听，是恢复过程中最被低估的一步。被相信、被陪伴，能显著降低孤立感带来的伤害。",
  },
];

export const legalPoints = [
  "公开他人姓名、住址、工作单位等个人信息，可能构成对公民个人信息的侵害。",
  "捏造事实并广泛传播、损害他人名誉，可能涉及诽谤，情节严重的需承担法律责任。",
  "使用侮辱性语言进行公开攻击，可能构成侮辱，可依法要求停止侵害并追究相应责任。",
  "维权时请注意：截图需包含网址、账号与时间；重要证据建议尽早做公证固定，避免被删除后无法取证。",
];

export const emergencyNotes = [
  "如果你此刻有人身安全风险，或收到明确的威胁信息，请优先拨打当地报警电话。",
  "如果出现持续的自伤念头，请立刻联系身边可信任的人，或寻求专业心理危机干预。",
  "暂时离开让你不断刷新、不断受伤的设备：把它交给家人保管，也是一种有效的自我保护。",
];